/**
* @author Camilo
* @since  22/11/2017
**/
export class MchResolucionesModel{

	constructor(public id:MchResolucionesId, public vresolucion:string, public ndesde:number, public nhasta:number, public nmesesresolucion:number, public dfechaexpedicion:Date, public dfechavencimiento:Date){}

}

export class MchResolucionesId{
	constructor(public cnumcont:string, public cprefijo:string, public ntipoempresa:number){}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Prefijo/MchResoluciones.model.ts